document.addEventListener('DOMContentLoaded', function() {
  // 保存初始滚动位置
  const initialScrollPos = window.scrollY || window.pageYOffset;
  
  // 防止页面加载时自动滚动
  setTimeout(() => {
    window.scrollTo(0, initialScrollPos);
  }, 500);
  
  // 获取所有需要的元素
  const listItems = document.querySelectorAll('.ai-list-item');
  const drawerOverlay = document.querySelector('.ai-drawer-overlay');
  const drawerContainer = document.querySelector('.ai-drawer-container');
  const drawerContents = document.querySelectorAll('.ai-drawer-content');
  
  // 产品详情弹窗初始化标志和存储
  window.aokProductDetails = window.aokProductDetails || {
    initialized: false,
    currentProductId: null,
    productData: null
  };
  
  // 关闭抽屉的函数
  function closeDrawer() {
    if (drawerContainer) {
      drawerContainer.classList.remove('slide-in');
      drawerContainer.classList.add('slide-out');
      
      // 立即移除所有内容的active类
      const allDrawerContents = document.querySelectorAll('.ai-drawer-content');
      allDrawerContents.forEach(content => {
        content.classList.remove('active');
      });
      
      // 添加动画完成后的处理
      setTimeout(() => {
        if (drawerOverlay) drawerOverlay.classList.remove('active');
        if (drawerContainer) {
          drawerContainer.classList.remove('active', 'slide-out');
        }
        document.body.style.overflow = '';
        
        // 再次确保所有内容都不处于活动状态
        const allDrawerContents = document.querySelectorAll('.ai-drawer-content');
        allDrawerContents.forEach(content => {
          content.classList.remove('active');
        });
      }, 300);
    }
  }
  
  // 为关闭按钮添加点击事件
  const drawerClose = document.querySelector('.ai-drawer-close');
  const rightCloseButton = document.querySelector('.aok-qz95-close-right');
  
  if (rightCloseButton) {
    rightCloseButton.addEventListener('click', closeDrawer);
  }
  
  if (drawerClose) {
    drawerClose.addEventListener('click', closeDrawer);
  }
  
  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', closeDrawer);
  }
  
  // 添加键盘 ESC 关闭功能
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawerContainer && drawerContainer.classList.contains('active')) {
      closeDrawer();
    }
  });
  
  // 点击列表项打开抽屉
  listItems.forEach(item => {
    item.addEventListener('click', function() {
      const drawerId = this.getAttribute('data-drawer');
      const drawerContent = document.getElementById(`${drawerId}-content`);
      
      // 更新标题图片
      const headerImage = document.querySelector('.ai-drawer-header-image');
      
      if (headerImage) {
        if (drawerId === 'ai-action') {
          headerImage.src = 'https://cdn.shopify.com/s/files/1/0535/9527/5424/files/1_e0d1de1b-a007-486b-a07d-43aa7c6bdd4a.png?v=1742531952';
          headerImage.style.display = 'block';
        } else if (drawerId === 'ai-story') {
          headerImage.src = 'https://cdn.shopify.com/s/files/1/0535/9527/5424/files/Heading_40.png?v=1742536070';
          headerImage.style.display = 'block';
        } else if (drawerId === 'ai-style') {
          headerImage.src = 'https://cdn.shopify.com/s/files/1/0535/9527/5424/files/2_41f7e6cf-cb1f-4685-b7cb-340cffb7bef6.png?v=1742531952';
          headerImage.style.display = 'block';
        } else if (drawerId === 'ai-details') {
          headerImage.src = '';
          headerImage.style.display = 'none';
          
          // 如果是产品详情，确保加载产品数据
          loadProductDetails();
        }
      }
      
      // 显示对应内容
      drawerContents.forEach(content => {
        if (content) content.classList.remove('active');
      });
      
      if (drawerContent) {
        drawerContent.classList.add('active');
      }
      
      // 显示抽屉
      if (drawerOverlay) drawerOverlay.classList.add('active');
      if (drawerContainer) {
        drawerContainer.classList.add('active', 'slide-in');
        drawerContainer.style.transform = '';  // Reset inline transform
      }
      document.body.style.overflow = 'hidden';
    });
  });

  // AI功能标签切换
  const navButtons = document.querySelectorAll('.feature-nav-btn');
  const featureCards = document.querySelectorAll('.feature-card');

  navButtons.forEach(button => {
    button.addEventListener('click', () => {
      // 移除所有活动状态
      navButtons.forEach(btn => btn.classList.remove('active'));
      featureCards.forEach(card => card.classList.remove('active'));

      // 添加新的活动状态
      button.classList.add('active');
      const targetCard = document.getElementById(button.dataset.tab);
      if (targetCard) {
        targetCard.classList.add('active');
      }
    });
  });

  // 配送信息功能
  // 初始化配送信息
  function initializeDeliveryInfo() {
    // 在页面完全加载后延迟执行，以防止任何可能的滚动影响
    setTimeout(() => {
      // 保存当前滚动位置
      const scrollPos = window.scrollY || window.pageYOffset;
      
      // 设置默认城市为Los Angeles
      const defaultCity = "Los Angeles";
      
      // 计算默认配送日期范围
      const deliveryDates = calculateDeliveryDates();
      
      // 更新主列表中的文本
      updateListItemText(defaultCity, deliveryDates);
      
      // 如果有预设地址显示区域，也可以预填充
      const deliveryAddress = document.getElementById('delivery-address');
      const deliveryDateRange = document.getElementById('delivery-date-range');
      
      if (deliveryAddress) {
        deliveryAddress.textContent = `${defaultCity}, CA`;
      }
      
      if (deliveryDateRange) {
        deliveryDateRange.textContent = deliveryDates;
      }
      
      // 恢复滚动位置
      window.scrollTo(0, scrollPos);
    }, 100);
  }
  
  // 页面加载时初始化配送信息
  initializeDeliveryInfo();
  
  // 计算配送日期范围
  function calculateDeliveryDates() {
    const today = new Date();
    
    // 第一个日期是今天 + 7天
    const firstDate = new Date(today);
    firstDate.setDate(today.getDate() + 7);
    
    // 第二个日期是今天 + 14天
    const secondDate = new Date(today);
    secondDate.setDate(today.getDate() + 14);
    
    // 格式化日期
    return `${formatDate(firstDate)} - ${formatDate(secondDate)}`;
  }
  
  // 格式化日期为MMM DD（例如，Mar 25）
  function formatDate(date) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[date.getMonth()];
    const day = date.getDate();
    
    return `${month} ${day}`;
  }
  
  // 更新列表项文本
  function updateListItemText(address, deliveryDates) {
    // 查找配送列表项
    const deliveryListItem = document.querySelector('.ai-list-item[data-drawer="ai-story"]');
    if (deliveryListItem) {
      const cityParts = address.split(',')[0]; // 仅获取城市名称
      const textElement = deliveryListItem.querySelector('.ai-item-text');
      
      if (textElement) {
        // 更新文本以包含城市和配送日期
        textElement.innerHTML = `
          <p>Est. Delivery to ${cityParts} ${deliveryDates}</p>
          <p style="color:var(--text-light)">Free shipping over $45</p>
        `;
      }
    }
  }
  
  // 处理zip码查询
  async function checkDeliveryEstimate() {
    const zipcode = document.getElementById('zipcode-input').value.trim();
    const zipcodeError = document.getElementById('zipcode-error');
    const deliveryResults = document.getElementById('delivery-results');
    const zipcodeCheckBtn = document.getElementById('zipcode-check-btn');
    
    // 清除先前的错误
    if (zipcodeError) zipcodeError.textContent = '';
    
    // 验证zipcode
    if (!zipcode) {
      if (zipcodeError) zipcodeError.textContent = 'Please enter a ZIP code';
      return;
    }
    
    // 显示加载状态
    if (zipcodeCheckBtn) {
      zipcodeCheckBtn.textContent = 'Checking...';
      zipcodeCheckBtn.disabled = true;
    }
    
    try {
      // 调用API获取城市信息
      const response = await fetch(`https://service.aoklok.com:3000/shopify/data/zipTocity?zip=${zipcode}`);
      const data = await response.json();
      
      let address = null;
      if (data.success) {
        // 格式化返回的城市数据
        address = `${data.data.city}, ${zipcode}`;
      }
      
      if (!address) {
        if (zipcodeError) zipcodeError.textContent = 'Invalid ZIP code. Please try again.';
        if (zipcodeCheckBtn) {
          zipcodeCheckBtn.textContent = 'Check';
          zipcodeCheckBtn.disabled = false;
        }
        return;
      }
      
      // 计算配送日期
      const deliveryDates = calculateDeliveryDates();
      
      // 更新UI
      const deliveryAddress = document.getElementById('delivery-address');
      const deliveryDateRange = document.getElementById('delivery-date-range');
      
      if (deliveryAddress) deliveryAddress.textContent = address;
      if (deliveryDateRange) deliveryDateRange.textContent = deliveryDates;
      if (deliveryResults) deliveryResults.style.display = 'block';
      
      // 同时更新主列表中的文本
      updateListItemText(address, deliveryDates);
      
      // 重置按钮
      if (zipcodeCheckBtn) {
        zipcodeCheckBtn.textContent = 'Check';
        zipcodeCheckBtn.disabled = false;
      }
    } catch (error) {
      console.error('Error checking delivery estimate:', error);
      if (zipcodeError) zipcodeError.textContent = 'An error occurred. Please try again.';
      if (zipcodeCheckBtn) {
        zipcodeCheckBtn.textContent = 'Check';
        zipcodeCheckBtn.disabled = false;
      }
    }
  }
  
  // 添加邮编查询事件监听器
  const zipcodeCheckBtn = document.getElementById('zipcode-check-btn');
  const zipcodeInput = document.getElementById('zipcode-input');
  
  if (zipcodeCheckBtn) {
    zipcodeCheckBtn.addEventListener('click', checkDeliveryEstimate);
  }
  
  if (zipcodeInput) {
    zipcodeInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        checkDeliveryEstimate();
      }
    });
  }
  
  // 当抽屉组件被移动到body时，确保事件监听器仍然起作用
  const moveDrawerToBody = () => {
    // 保存当前滚动位置
    const scrollPos = window.scrollY || window.pageYOffset;
    
    const drawerComponents = document.getElementById('ai-drawer-components');
    if (drawerComponents && document.body) {
      document.body.appendChild(drawerComponents);
      console.log('抽屉组件已移动到body');
      
      // 恢复滚动位置
      window.scrollTo(0, scrollPos);
      
      // 防止任何可能的自动滚动
      setTimeout(() => {
        window.scrollTo(0, scrollPos);
      }, 100);
    }
  };
  
  // 执行抽屉组件的移动
  moveDrawerToBody();

  // 产品详情相关函数
  async function loadProductDetails() {
    // 如果已经初始化过，不再重复加载
    if (window.aokProductDetails.initialized) {
      return;
    }
    
    // 获取当前产品ID
    const productId = getCurrentProductId();
    if (!productId) {
      console.error('无法获取当前产品ID');
      return;
    }
    
    window.aokProductDetails.currentProductId = productId;
    
    try {
      // 显示加载状态
      const detailsContent = document.getElementById('ai-details-content');
      if (detailsContent) {
        detailsContent.innerHTML = '<div class="aok_details_loading" style="text-align: center; padding: 20px;"><p>Loading product details...</p></div>';
      }
      
      // 获取产品数据
      const productData = await fetchProductData(productId);
      if (!productData) {
        throw new Error('无法获取产品数据');
      }
      
      window.aokProductDetails.productData = productData;
      
      // 填充产品详情到弹窗
      populateProductDetails(productData);
      
      // 标记为已初始化
      window.aokProductDetails.initialized = true;
    } catch (error) {
      console.error('加载产品详情时出错:', error);
      
      // 显示错误信息
      const detailsContent = document.getElementById('ai-details-content');
      if (detailsContent) {
        detailsContent.innerHTML = `<div class="aok_details_error" style="text-align: center; padding: 20px; color: #ff5252;">
          <p>Failed to load product details. Please try again later.</p>
        </div>`;
      }
    }
  }
  
  // 获取当前产品ID的辅助函数
  function getCurrentProductId() {
    // 从URL获取
    const urlParams = new URLSearchParams(window.location.search);
    const productId = urlParams.get('id');
    
    if (productId) return productId;
    
    // 从页面上的产品部分获取
    const productSection = document.querySelector('.product-section');
    if (productSection && productSection.dataset.productId) {
      return productSection.dataset.productId;
    }
    
    // 从meta标签获取
    const productMeta = document.querySelector('meta[property="og:product_id"]');
    if (productMeta) {
      return productMeta.content;
    }
    
    // 从标记数据获取
    const productJson = document.querySelector('[data-product-json]');
    if (productJson) {
      try {
        const productData = JSON.parse(productJson.textContent);
        return productData.id;
      } catch (e) {
        console.error('解析产品JSON失败:', e);
      }
    }
    
    return null;
  }
  
  // 获取产品数据的函数
  async function fetchProductData(productId) {
    try {
      // 使用GraphQL API获取数据
      const response = await fetch(`https://Kclot.myshopify.com/api/2023-01/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": "72859f55af4df22334c189753571fd62"
        },
        body: JSON.stringify({
          query: `{
            product(id: "gid://shopify/Product/${productId}") {
              id
              title
              handle
              vendor
              description
              productType
              tags
              availableForSale
              priceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
              }
              images(first: 1) {
                edges {
                  node {
                    originalSrc
                  }
                }
              }
              variants(first: 1) {
                edges {
                  node {
                    id
                    sku
                    title
                    price {
                      amount
                      currencyCode
                    }
                    availableForSale
                  }
                }
              }
              metafield_materials: metafield(namespace: "custom", key: "materials") {
                value
              }
              metafield_sizing: metafield(namespace: "custom", key: "sizing") {
                value
              }
              metafield_dimensions: metafield(namespace: "custom", key: "dimensions") {
                value
              }
              metafield_specifications: metafield(namespace: "custom", key: "specifications") {
                value
              }
            }
          }`
        })
      });
      
      const data = await response.json();
      
      // 检查数据
      if (data.errors) {
        console.error('GraphQL API返回错误:', data.errors);
        return null;
      }
      
      if (!data.data || !data.data.product) {
        console.error('GraphQL API返回的数据不包含产品信息');
        return null;
      }
      
      return formatProductData(data.data.product);
    } catch (error) {
      console.error('获取产品数据时出错:', error);
      return null;
    }
  }
  
  // 格式化产品数据
  function formatProductData(apiData) {
    const firstImage = apiData.images.edges[0]?.node?.originalSrc || '';
    const firstVariant = apiData.variants.edges[0]?.node || {};
    const price = firstVariant.price?.amount || apiData.priceRange?.minVariantPrice?.amount || '0';
    const formattedPrice = formatMoney(price, apiData.priceRange?.minVariantPrice?.currencyCode || 'USD');
    
    // 尝试获取产品元数据
    const materials = apiData.metafield_materials?.value || '';
    const sizing = apiData.metafield_sizing?.value || '';
    const dimensions = apiData.metafield_dimensions?.value || '';
    const specifications = apiData.metafield_specifications?.value || '';
    
    return {
      id: apiData.id.split('/').pop(),
      title: apiData.title,
      handle: apiData.handle,
      vendor: apiData.vendor,
      productType: apiData.productType,
      description: apiData.description,
      tags: apiData.tags || [],
      price: formattedPrice,
      image: firstImage,
      sku: firstVariant.sku || 'N/A',
      variantTitle: firstVariant.title || '',
      materials: materials,
      sizing: sizing,
      dimensions: dimensions,
      specifications: specifications,
      available: apiData.availableForSale
    };
  }
  
  // 格式化金额
  function formatMoney(amount, currencyCode = 'USD') {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode,
    });
    
    return formatter.format(parseFloat(amount));
  }
  
  // 填充产品详情到弹窗
  function populateProductDetails(productData) {
    const detailsContent = document.getElementById('ai-details-content');
    if (!detailsContent) return;
    
    // 清空当前内容
    detailsContent.innerHTML = '';
    
    // 创建产品详情容器
    const container = document.createElement('div');
    container.className = 'aok_details_container';
    
    // 添加标题和价格
    const header = document.createElement('div');
    header.className = 'aok_details_header';
    header.innerHTML = `
      <h3 class="aok_details_title">${productData.title}</h3>
      <div class="aok_details_price">${productData.price}</div>
    `;
    container.appendChild(header);
    
    // 添加分隔线
    function createDivider() {
      const divider = document.createElement('div');
      divider.className = 'aok_details_divider';
      return divider;
    }
    container.appendChild(createDivider());
    
    // 添加基本信息
    const basicInfo = document.createElement('div');
    basicInfo.className = 'aok_details_basic';
    basicInfo.innerHTML = `
      <div class="aok_details_basic_item">
        <span class="aok_details_label">SKU:</span>
        <span class="aok_details_value">${productData.sku || 'N/A'}</span>
      </div>
      <div class="aok_details_basic_item">
        <span class="aok_details_label">Vendor:</span>
        <span class="aok_details_value">${productData.vendor || 'N/A'}</span>
      </div>
      <div class="aok_details_basic_item">
        <span class="aok_details_label">Type:</span>
        <span class="aok_details_value">${productData.productType || 'N/A'}</span>
      </div>
      <div class="aok_details_basic_item">
        <span class="aok_details_label">Availability:</span>
        <span class="aok_details_value ${productData.available ? 'aok_details_in_stock' : 'aok_details_out_stock'}">
          ${productData.available ? 'In Stock' : 'Out of Stock'}
        </span>
      </div>
    `;
    container.appendChild(basicInfo);
    
    // 添加分隔线
    container.appendChild(createDivider());
    
    // 添加产品描述
    const description = document.createElement('div');
    description.className = 'aok_details_description';
    description.innerHTML = `
      <h4 class="aok_details_section_title">Product Description</h4>
      <div class="aok_details_description_content">
        ${productData.description || 'No description available.'}
      </div>
    `;
    container.appendChild(description);
    
    // 如果有规格参数信息，添加规格部分
    if (productData.specifications) {
      container.appendChild(createDivider());
      const specs = document.createElement('div');
      specs.className = 'aok_details_specifications';
      specs.innerHTML = `
        <h4 class="aok_details_section_title">Specifications</h4>
        <div class="aok_details_specifications_content">
          ${productData.specifications}
        </div>
      `;
      container.appendChild(specs);
    }
    
    // 如果有材料信息，添加材料部分
    if (productData.materials) {
      container.appendChild(createDivider());
      const materials = document.createElement('div');
      materials.className = 'aok_details_materials';
      materials.innerHTML = `
        <h4 class="aok_details_section_title">Materials</h4>
        <div class="aok_details_materials_content">
          ${productData.materials}
        </div>
      `;
      container.appendChild(materials);
    }
    
    // 如果有尺寸或尺寸信息，添加尺寸部分
    if (productData.sizing || productData.dimensions) {
      container.appendChild(createDivider());
      const sizing = document.createElement('div');
      sizing.className = 'aok_details_sizing';
      sizing.innerHTML = `
        <h4 class="aok_details_section_title">Sizing & Dimensions</h4>
        <div class="aok_details_sizing_content">
          ${productData.sizing || productData.dimensions || ''}
        </div>
      `;
      container.appendChild(sizing);
    }
    
    // 将完整的容器添加到弹窗
    detailsContent.appendChild(container);
    
    // 设置为活动状态，确保显示内容
    detailsContent.classList.add('active');
    
    // 添加CSS样式
    addProductDetailsStyles();
  }
  
  // 添加产品详情样式
  function addProductDetailsStyles() {
    // 检查是否已添加样式
    if (document.getElementById('aok_details_styles')) return;
    
    const styleElement = document.createElement('style');
    styleElement.id = 'aok_details_styles';
    styleElement.textContent = `
      /* 产品详情弹窗样式 */
      .aok_details_container {
        padding: 25px 20px;
        max-width: 100%;
        color: #333;
      }
      
      .aok_details_header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 20px;
      }
      
      .aok_details_title {
        font-size: 1.5rem;
        font-weight: 600;
        color: #333;
        margin: 0;
        line-height: 1.3;
        flex: 1;
      }
      
      .aok_details_price {
        font-size: 1.3rem;
        font-weight: 600;
        color: #1e613c;
        margin-left: 15px;
      }
      
      .aok_details_divider {
        height: 1px;
        background-color: #eee;
        margin: 20px 0;
      }
      
      .aok_details_basic {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 15px;
        margin-bottom: 5px;
      }
      
      .aok_details_basic_item {
        display: flex;
        flex-direction: column;
      }
      
      .aok_details_label {
        font-size: 0.9rem;
        color: #777;
        margin-bottom: 5px;
      }
      
      .aok_details_value {
        font-size: 1rem;
        color: #333;
        font-weight: 500;
      }
      
      .aok_details_in_stock {
        color: #1e613c;
      }
      
      .aok_details_out_stock {
        color: #d9534f;
      }
      
      .aok_details_section_title {
        font-size: 1.1rem;
        font-weight: 600;
        color: #1e613c;
        margin: 0 0 15px 0;
      }
      
      .aok_details_description_content,
      .aok_details_materials_content,
      .aok_details_sizing_content {
        font-size: 0.95rem;
        line-height: 1.6;
        color: #555;
      }
      
      /* 格式化产品描述中可能的HTML元素 */
      .aok_details_description_content p,
      .aok_details_materials_content p,
      .aok_details_sizing_content p {
        margin-bottom: 12px;
      }
      
      .aok_details_description_content ul,
      .aok_details_description_content ol,
      .aok_details_materials_content ul,
      .aok_details_materials_content ol,
      .aok_details_sizing_content ul,
      .aok_details_sizing_content ol {
        padding-left: 20px;
        margin-bottom: 12px;
      }
      
      .aok_details_description_content li,
      .aok_details_materials_content li,
      .aok_details_sizing_content li {
        margin-bottom: 5px;
      }
      
      /* 移动端适配 */
      @media (max-width: 767px) {
        .aok_details_container {
          padding: 20px 15px;
        }
        
        .aok_details_header {
          flex-direction: column;
        }
        
        .aok_details_price {
          margin-left: 0;
          margin-top: 10px;
        }
        
        .aok_details_basic {
          grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
        }
      }
      
      /* 确保内容在弹窗内正确显示 */
      #ai-details-content.active {
        display: block !important;
      }
      
      .aok_details_error {
        padding: 30px 20px;
        text-align: center;
        color: #d9534f;
      }
      
      .aok_details_loading {
        padding: 30px 20px;
        text-align: center;
        color: #777;
      }
    `;
    document.head.appendChild(styleElement);
  }
}); 